import { handleActions, combineActions } from 'redux-actions'
import { getReadonlyContentSuccess } from '@tabeeb/shared/content/actions'
import { getContentForms, resetFormsState } from '../actions'

const defaultState: {
  loading: boolean
  loaded: boolean
} = {
  loading: false,
  loaded: false,
}

export default handleActions(
  {
    [getContentForms.request.toString()](state) {
      return { ...state, loading: true }
    },
    [combineActions(getContentForms.success, getContentForms.failed, getReadonlyContentSuccess).toString()](state) {
      return { ...state, loading: false, loaded: true }
    },
    [resetFormsState.toString()]() {
      return defaultState
    },
  },
  defaultState
)
